import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getDangerousGoodPackageList(params) {
  return request({
    url: URL.mdm.basicData.dangerousGoodPackage,
    method: 'get',
    params
  })
}

export function saveDangerousGoodPackage(data) {
  return request({
    url: URL.mdm.basicData.dangerousGoodPackage,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delDangerousGoodPackage(uuid) {
  return request({
    url: URL.mdm.basicData.dangerousGoodPackage + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
